import { createNamespacedHelpers } from 'vuex';
import { DefineActions, DefineGetters, DefineMutations } from 'vuex-type-helper';
import { Routes, Getters, Mutations, Actions } from '@/models/Route.model';

// Inital state
const state: Routes = {
  routes: [],
  rateTypes: [],
  adjustmentHeaders: [],
};

// Gets the values of our state usually called from components
const getters: DefineGetters<Getters, Routes> = {
  routes: (state) => state.routes,
  rateTypes: (state) => state.rateTypes,
  adjustmentHeaders: (state) => state.adjustmentHeaders,
};

// TODO: Change mutation names to uppercase ( Standards )
// Sets values or changes to state. Must be called via an action.
const mutations: DefineMutations<Mutations, Routes> = {
  setRoutes(state, { routes }) {
    state.routes = routes;
  },

  setRateTypes(state, { rateTypes }) {
    state.rateTypes = rateTypes;
  },

  setAdjustmentHeaders(state, { adjustmentHeaders }) {
    state.adjustmentHeaders = adjustmentHeaders;
  },
};

// Async functions that will contain the logic / service calls and commit mutations to state
const actions: DefineActions<Actions, Routes, Mutations, Getters> = {
  setRoutes({ commit }, payload) {
    commit('setRoutes', payload);
  },

  setRateTypes({ commit }, payload) {
    commit('setRateTypes', payload);
  },

  setAdjustmentHeaders({ commit }, payload) {
    commit('setAdjustmentHeaders', payload);
  },
};

export const {
  mapState,
  mapGetters,
  mapMutations,
  mapActions,
} = createNamespacedHelpers<Routes, Getters, Mutations, Actions>('RoutesModule');

export const RoutesModule = {
  namespaced: true,
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions,
};
